// Supabase client — real connection (shared DB with mobile app)
// Web version: uses localStorage for session persistence (mobile uses SecureStore)
import { createClient } from '@supabase/supabase-js';
import { env } from '@config/env.js';

const SUPABASE_URL = env.supabaseUrl;
const SUPABASE_ANON_KEY = env.supabaseAnonKey;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY || SUPABASE_URL === 'https://placeholder.supabase.co') {
  console.error(
    '[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY — check your .env file'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // Needed for OAuth / magic link on web
    storage: localStorage,    // Web uses localStorage (mobile uses SecureStore)
  },
});
